












































import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Validator } from 'vee-validate';
import { Base } from './base';
import { customerService } from '@/shared';
import { GetArHistoryResponse, Search } from '@/Alynk.dtos';
import { IDialogOption } from '@/models/dialog';

@Component({
    components: {
        Grid: () => import('./app.grid.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue')
    },
    props: ['dialog']
})

export default class EmailTrackingComponent extends Base {
    get trigger(): boolean {
        return this.$props.dialog;
    }
    set trigger(val) {
        this.$emit('closedialog', val);
    }

    get filteredItems() {
        if (!this.pagination.search) return this.items;

        const search = this.pagination.search.toLowerCase();

        return this.items.filter(item =>
            Object.values(item).some(val =>
                val && val.toString().toLowerCase().includes(search)
            )
        );
    }

    get filteredstatusItems() {
        if (!this.mailSearch) return this.mailitems;

        const search = this.mailSearch.toLowerCase();

        return this.mailitems.filter(item =>
            Object.values(item).some(val =>
                val && val.toString().toLowerCase().includes(search)
            )
        );
    }

    public $validator: Validator;
    public loading: boolean = false;
    public loadingdata: boolean = false;
    public pagination = new PaginationModel('createdAt', true, 5);
    public dialog: boolean;
    public email1: string;
    public email2: string;
    public storeId: number = 0;
    public tenantId: number = 0;
    public enterpriseId: number = 0;
    public actions: any[] = [];
    public mailitems: any[] = [];
    public items: any[] = [];
    public attachmentFilters: string[] = ["All", "Failed", "Sent"];
    public attachmentFilter: string = "All";
    public headers: VHeaders[] = [];
    public mailheaders: VHeaders[] = [];
    public mailSearch: string = '';
    public selectedCreatedAt: string | null = null;
    public setHeaders() {
        this.headers = [
            {
                text: 'Email',
                align: 'left',
                sortable: true,
                value: 'userName',
            },
            {
                text: 'Mail Count',
                align: 'left',
                sortable: true,
                value: 'mailCount',
            },
            {
                text: 'Email Count',
                align: 'left',
                sortable: true,
                value: 'emailCount',
            },
            {
                text: 'Date Time',
                value: 'createdAt',
                align: 'left',
                fieldType: 'date',
            },
            {
                text: 'Action',
                align: 'center',
                isNotDataProp: true,
                sortable: false,
            },
        ];

        this.mailheaders = [
            {
                text: 'Customer Name',
                align: 'left',
                sortable: true,
                value: 'customerName'
            },
            {
                text: 'Customer Number',
                align: 'left',
                sortable: true,
                value: 'customerNumber'
            },
            {
                text: 'Email',
                align: 'left',
                sortable: true,
                value: 'isEmailSuccess',
                fieldType: 'template',
                template: (item) => {
                    return `<v-icon :color="'${item.isEmailSuccess ? 'success' : 'error'
                        }'"> fa fa-envelope </v-icon>`;
                },
            },
            {
                text: 'Mail',
                align: 'left',
                sortable: true,
                value: 'isMailSuccess',
                fieldType: 'template',
                template: (item) => {
                    return `<v-icon :color="'${item.isMailSuccess ? 'success' : 'error'
                        }'"> fa fa-envelope </v-icon>`;
                },
            },
            {
                text: 'EmailReason',
                align: 'left',
                sortable: true,
                value: 'emailFailResponse'
            },
            {
                text: 'MailReason',
                align: 'left',
                sortable: true,
                value: 'mailFailResponse'
            }
        ];

    }

    public mounted() {
        this.$watch('dialog', (newVal, oldVal) => {
            if (newVal) {
                this.getTrackingRecords(newVal);
            }
        });
        this.setHeaders();
        this.setAction();
    }

    public mailEmailDialog: IDialogOption = {
        model: false,
        width: 900
    };
    public async getTrackingRecords(recordKey): Promise<void> {
        try {
            this.loading = true;
            const response = await customerService.getArHistory();
            this.items = [];
            this.items = response.results;
            if (this.items) {
                this.pagination.totalItems = response.results.length || 0;
            }
        }
        finally {
            this.setHeaders();
            this.setAction();
            this.loading = false;
        }
    }

    public closeDialog() {
        this.trigger = false;
        this.mailEmailDialog.model = false;
        this.mailitems = [];
        this.$validator.reset();
    }

    public setAction() {
        this.actions =
            [
                {
                    type: 'button',
                    icon: 'fas fa-eye',
                    title: 'View Status',
                    action: (item) => {
                        this.openMailStatusDialog(item);
                    }
                }
            ];
    }

    public async openMailStatusDialog(item: GetArHistoryResponse) {
        try {
            this.loadingdata = true;
            this.mailEmailDialog.model = true;
            this.selectedCreatedAt = item.createdAt;
            this.attachmentFilter = "All";
            const response = await customerService.GetMailEmailStatusReport(this.attachmentFilter, item.createdAt);
            this.mailitems = [];
            this.mailitems = response || [];

        }
        finally {
            this.setHeaders();
            this.loadingdata = false;
        }
    }

    public async onFilterChange() {
        try {
            this.loadingdata = true;
            const response = await customerService.GetMailEmailStatusReport(this.attachmentFilter, this.selectedCreatedAt);
            this.mailitems = [];
            this.mailitems = response || [];
        }
        finally {
            this.loadingdata = false;
        }
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
}
